<template lang="pug">
el-dialog(width="750px", title="数据选择", :visible.sync="visible", :close-on-click-modal="false", @closed="reject()")
  ul.filter-list
    li
      el-button.block(type="primary", plain, icon="el-icon-plus", @click="addFiler") 添加条件
    li(v-for="row in filterForm", :key="row.field")
      el-input(v-model="row.keyword", size="mini", @keypress.native.enter="submitFilter")
        template(#prepend)
          el-select(v-model="row.field", filterable, style="width: 120px")
            el-option(v-for="{ id, cnName } in filterFieldList", :key="id", :label="cnName", :value="id")
        template(#append)
          el-button(icon="el-icon-delete", @click="removeFiler(row)")
    li(v-if="filterForm.length")
      el-button.block(type="primary", @click="submitFilter") 筛选
  el-table(ref="table", :data="pageData", @selection-change="setSelection", :row-key="idKey")
    el-table-column(v-if="multiple", type="selection", align="center", reserve-selection)
    el-table-column(v-else, align="center", width="50px")
      template(v-slot="{ row }")
        el-radio(v-model="radioValue", :label="row[idKey]") #[span]
    el-table-column(v-for="{ id, cnName } in columnInfoList", :key="id", min-width="150px", :prop="id", :label="cnName")
  el-pagination(
    background,
    layout="total, sizes, prev, pager, next, jumper",
    :page-sizes="sizes",
    :current-page="page.pageNum",
    :page-size="page.pageSize",
    :total="totalCount",
    @current-change="setPageNum",
    @size-change="setPageSize"
  )
  template(#footer)
    el-button(@click="close()") 取消
    el-button(type="primary", @click="submit()") 确定
</template>
<script>
import { asyncMixin } from "@/CommonDP/commons/asyncCom";
import service from "@/CommonDP/service/metadata-service.js";
export default {
  mixins: [asyncMixin],
  data() {
    return {
      fieldVm: {},
      visible: false,
      fieldList: [], // 所有的
      columnField: [], // 仅在列表显示的
      fieldDict: [], // 字段全数据
      ids: [],
      filterForm: [],
      filters: [],
      list: [],
      sizes: [5, 10, 15, 20, 30, 40, 50, 100, 200, 300, 400, 500, 1000, 5000, 10000],
      page: { pageNum: 1, pageSize: 10 }
    };
  },
  computed: {
    radioValue: {
      set(val) {
        this.ids = val ? [val] : [];
      },
      get() {
        return this.ids?.[0];
      }
    },
    multiple() {
      return this.fieldVm.multiple;
    },
    totalCount() {
      return this.filterData.length;
    },
    idKey() {
      return this.fieldVm.idKey;
    },
    filterData() {
      return this.filters.reduce(
        (data, { field, list }) =>
          data.filter((item) => {
            const value = item[field];
            const str = typeof value === "number" ? `${value}` : value;
            return typeof str === "string" ? list.some((keyword) => str.toLowerCase().indexOf(keyword) > -1) : false;
          }),
        this.list
      );
    },
    pageData() {
      const {
        page: { pageSize, pageNum }
      } = this;
      return this.filterData.slice((pageNum - 1) * pageSize, pageSize * pageNum);
    },
    columnInfoList() {
      return this.columnField.map(this.getFieldInfo);
    },
    filterFieldList() {
      const {
        fieldList,
        fieldVm: {
          options: { filterField }
        }
      } = this;
      const list = filterField?.length ? filterField : fieldList;
      return list.map(this.getFieldInfo);
    }
  },
  created() {
    this.open();
  },
  methods: {
    getFieldInfo(key) {
      const { columnDisplayName: cnName, columnName: id } = this.fieldDict.find(({ columnName }) => columnName === key) || { columnName: key, columnDisplayName: key };
      return { id, cnName };
    },
    submitFilter() {
      const { filterForm, fieldList } = this;
      this.filters = fieldList
        .map((id) => ({
          field: id,
          list: filterForm
            .filter(({ field }) => field === id)
            .map(({ keyword }) => keyword.trim().toLowerCase())
            .filter((keyword) => keyword)
        }))
        .filter(({ list }) => list.length);
      this.setPageNum(1);
    },
    setPageSize(size) {
      this.page.pageNum = 1;
      this.page.pageSize = size;
    },
    setPageNum(index) {
      this.page.pageNum = index;
    },
    setSelection(selection = []) {
      const { idKey } = this;
      this.ids = selection.map(({ [idKey]: id }) => id);
    },
    async open() {
      const { fieldVm, idKey } = this;
      this.fieldList = fieldVm.metaParams.queryFieldList;
      this.columnField = fieldVm.options.columnField || [];
      const preList = [];
      const sufList = [];
      const value = fieldVm.fieldModel || "";
      const splitter = fieldVm.splitter;
      const ids = value ? value.split(splitter) : [];
      for (const item of fieldVm.list) {
        const id = item[idKey];
        const list = ids.indexOf(id) !== -1 ? preList : sufList;
        list.push(item);
      }
      const list = [...preList, ...sufList];
      this.list = list;
      this.ids = ids;
      this.visible = true;
      await this.$nextTick();
      if (this.multiple) {
        const table = this.$refs.table;
        for (const row of preList) table.toggleRowSelection(row, true);
      }
      this.getColumnList(fieldVm.options.tableId);
    },
    close() {
      this.visible = false;
    },
    submit() {
      const splitter = this.fieldVm.splitter;
      const str = this.ids.join(splitter);
      this.resolve(str);
      this.visible = false;
    },
    async removeFiler(row) {
      await this.$confirm("确定删除?", "警告", { type: "warning" });
      const index = this.filterForm.indexOf(row);
      if (index !== -1) this.filterForm.splice(index, 1);
      this.submitFilter();
    },
    addFiler() {
      this.filterForm.push({
        field: "",
        keyword: ""
      });
    },
    async getColumnList(tableId) {
      if (!tableId) return;
      const { data } = await service.columnList(tableId);
      this.fieldDict = data;
    }
  }
};
</script>
<style lang="scss" scoped>
.block {
  display: block;
  width: 100%;
}
.filter-list {
  > li {
    margin: 8px 4px;
  }
}
</style>
